export default{
    initFontSize() {
        const that = this;
        if (typeof WeixinJSBridge === 'undefined'){
            setTimeout(function(){
                that.initFontSize()
            }, 100);
            return;
        }
        WeixinJSBridge.invoke('setFontSizeCallback', {
            'fontSize': 0
        });
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function () {
            WeixinJSBridge.invoke('setFontSizeCallback', {
                'fontSize': 0
            });
        });
    }
}
